<template>
    <div class="container">
        <section class="section">
            <div class="u-mb-3">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Settings</div>
                    </div>
                </div>
            </div>
            <div class="section__content">
                <ul class="nav nav-tabs d-none d-lg-flex justify-content-start nav-tabs" role="tablist">
                    <li class="nav-item">
                        <button @click="$router.push('/settings/profile')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Profile</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/preferences')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Preferences</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/verification')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Verification</span></div>
                        </button>
                    </li>
                    <li class="nav-item nav-item--active">
                        <button @click="$router.push('/settings/security')" class="btn btn--tertiary btn--block nav-link nav-link--active rounded-0 m-auto"
                                type="button" data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="true">
                            <div class="nav-link__tab"><span class="nav-link__label">Security</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/payment-methods')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Payment methods</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/apps')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Apps</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/limits')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Limits</span></div>
                        </button>
                    </li>
                </ul>
                <div class="dropdown d-block d-lg-none tabs-dropdown">
                    <div class="dropdown-toggle d-block w-100 py-1" id="settings-toggle" aria-haspopup="true"
                         aria-expanded="false"><h4 class="m-0">Security</h4></div>
                </div>
                <hr class="d-block d-lg-none mt-0">
                <div class="card">
                    <div class="card__body">
                        <div class="d-flex">
                            <div class="flex-shrink-0 mr-4 d-none d-sm-block"><img
                                    src="@/assets/img/2fae03c886e51ef54196aab.svg" class="icon icon--64 text--primary"
                                    alt="avatar"></div>
                            <div class="flex-grow-1"><p class="mb-1"><span>Security level: </span><strong
                                    class="text--headings">2/3</strong></p><span
                                    class="progress-bar progress-bar--primary"><span
                                    class="progress-bar__inner progress-bar__inner--66 progress-bar__inner--primary progress-bar__inner--determinate"></span></span>
                                <p class="mb-0 mt-2 font--sm font-weight--bold text--headings"><span>Next </span><span>Enable 2FA for login</span>
                                </p></div>
                        </div>
                    </div>
                </div>
                <hr>
                <h3>Password</h3>
                <button class="btn btn--tertiary-icon-after px-0 py-2" type="button" data-loading="false"
                        aria-expanded="false">
                    <div class="d-flex flex-row justify-content-center align-items-center  flex-gap-12">
                        <div>Change password</div>
                        <div>
                            <svg viewBox="0 0 24 24" class="icon icon--18">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M17.45 1.922a3.043 3.043 0 0 0-1.39.641C15.631 2.906 2.667 15.92 2.504 16.17a3.159 3.159 0 0 0-.414.945c-.056.223-.067.502-.068 1.765l-.002 1.5.111.189a.862.862 0 0 0 .3.3l.189.111 1.5-.002c1.263-.001 1.542-.012 1.765-.068a2.9 2.9 0 0 0 .99-.456c.308-.215 13.196-13.063 13.569-13.526.473-.588.652-1.116.652-1.928 0-.393-.019-.611-.071-.8-.286-1.046-1.175-1.941-2.205-2.219-.289-.077-1.078-.112-1.37-.059m.933 2.025c.264.09.58.406.67.67.085.249.085.513.002.766-.06.182-.579.712-6.65 6.79-3.849 3.853-6.66 6.637-6.765 6.7-.175.104-.2.107-.913.12l-.733.013.013-.733c.013-.713.016-.738.12-.913.063-.105 2.848-2.917 6.7-6.766 7.185-7.176 6.681-6.703 7.156-6.711.111-.002.291.027.4.064m-6.764 15.109c-.241.075-.371.176-.491.38-.097.165-.108.223-.108.564 0 .343.011.398.111.569a.862.862 0 0 0 .3.3l.189.111h9.766l.195-.12c.247-.153.38-.397.408-.751.028-.344-.066-.664-.25-.847-.274-.274-.031-.262-5.256-.259-3.664.002-4.739.013-4.864.053"></path>
                            </svg>
                        </div>
                    </div>
                </button>
                <hr>
                <h3>Two-factor authentication</h3>
                <p>May require app installs on your smartphone.</p>
                <div>
                    <div class="switch"><input name="login" type="checkbox" id="switch-mfa-login"><label
                            for="switch-mfa-login" class="switch__label switch__label--after">Login</label></div>
                    <div class="switch"><input name="operations" type="checkbox" id="switch-mfa-operations"
                                               checked=""><label for="switch-mfa-operations"
                                                                 class="switch__label switch__label--after">Transactions</label>
                    </div>
                </div>
                <br>
                <button class="btn btn--primary" type="button" data-loading="false" aria-expanded="false"
                        id="reset-mfa-btn" name="reset-mfa">Reset 2FA
                </button>
                <hr>
                <h3>Account Deletion</h3>
                <p>Delete your Airtm account. This action is not reversible!</p>
                <button class="btn btn--destructive" type="button" data-loading="false" aria-expanded="false">Delete
                    account
                </button>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "security",
    }
</script>

<style scoped>

</style>